// components/ui/ViewModeLayout.jsx
import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faPlusCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const ViewModeLayout = ({
    viewMode,
    onShowGeneratorView,
    onShowHistoryView,
    historyTitle,
    generatorTitle,
    historyIcon,
    generatorIcon,
    newItemButtonText,
    children // To render either history content or generator content
}) => {
    return (
        <Card className="shadow-lg border-0 rounded-3 mb-4">
            <Card.Header
                as="h2"
                className="text-white text-center p-3 d-flex justify-content-between align-items-center"
                style={{ background: 'linear-gradient(to right, var(--bs-primary, #0d6efd), var(--bs-success, #198754))' }} // Generic gradient, can be customized via props if needed
            >
                <span>
                    <FontAwesomeIcon icon={viewMode === 'history' ? historyIcon : generatorIcon} className="me-2" />
                    {viewMode === 'history' ? historyTitle : generatorTitle}
                </span>
                {viewMode === 'history' ? (
                    <Button variant="light" size="md" onClick={onShowGeneratorView} className="shadow-sm rounded-pill">
                        <FontAwesomeIcon icon={faPlusCircle} className="me-1" /> {newItemButtonText}
                    </Button>
                ) : (
                    <Button variant="light" size="md" onClick={onShowHistoryView} className="shadow-sm rounded-pill">
                        <FontAwesomeIcon icon={faArrowLeft} className="me-1" /> Back to History
                    </Button>
                )}
            </Card.Header>
            <Card.Body className="p-4">
                {children}
            </Card.Body>
            {/* Global styles for history items and save buttons can be kept in parent or moved here if truly generic */}
        </Card>
    );
};

export default ViewModeLayout;